import React from 'react';

import WhiteBox from '../WhiteBox';

type FloatingMessageProps = {
  className?: string;
  children?: React.ReactNode;
  onCancel?: () => void;
  onConfirm?: () => void;
};

function FloatingMessage({className, children}: FloatingMessageProps) {
  return (
    <WhiteBox
      className={`absolute z-50 rounded-large ${className} `}
      showShadow
    >
      {children}
    </WhiteBox>
  );
}

export default FloatingMessage;
